import React, {useState} from 'react'
import "./main.scss"

const NavigationDots = ({active}) => {
  const [control, setControl] = useState(false)
  return (
    <div className="app__navigation">

        {['home', 'about', 'work', 'skills', 'contact'].map((item, index) => (
          <a href={`#${item}`} key={item + index} className="app__navigation-dot" style={active === item? {backgroundColor: "#313BAC"}: {}} />

        ))}
    </div>
    

  )
}

export default NavigationDots